export default (params) => ({
  trigger: {
    name: 'content_blocks.detailed_visual_entrances.select_entrance',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      url: {
        type: 'string',
      },
      redirect: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'main_category',
          'sub_category',
          'overarching_category',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_navigation',
    },
    nonInt: false,
  },
});
